import React, { useEffect, useState } from 'react'
// Ant Design
import { Flex, Image, Typography, Input, Checkbox, Button, message } from 'antd'
// Ant Design Icons
import { UserOutlined, LockOutlined } from '@ant-design/icons'
// React Router
import { useNavigate } from 'react-router-dom';
// Assets
import LogoMurphy from '../Assets/logoStadistics.png'
// Crypto Js
import CryptoJS from 'crypto-js'
// i18
import { useTranslation } from 'react-i18next'
// Axios
import axios from 'axios'
// Config
import config from '../config'
import { getConfig } from '../config'

export const Login = () => {
    const { Title } = Typography
    const [messageApi, contextHolder] = message.useMessage()
    const { t } = useTranslation(["translation"])
    const navigate = useNavigate()

    const [user, setUser] = useState("")
    const [password, setPassword] = useState("")
    const [check, setCheck] = useState(false)
    const [cargando, setCargando] = useState(false)

    const onLogin = async() => {
        if(user==="" || password==="") {
            messageApi.info(t("fill_all_fields"));
        }
        else {
            setCargando(true)

            const data = {
                email: user,
                password: password
            }

            try {
                const res = await axios.post(config.urlApi + "/login", data, {
                    withCredentials: true
                })
                if(res.status === 201) {
                    setCargando(false)
                    localStorage.setItem("user", user)

                    if(check) {
                        const encryPass = CryptoJS.AES.encrypt(password, config.passEncrypt).toString()
                        localStorage.setItem("pass", encryPass)
                    }
                    else {
                        localStorage.removeItem("pass")
                    }
                    
                    localStorage.setItem("admin", res.data.is_admin)
                    navigate("/new")
                }
            }
            catch(error) {
                setCargando(false)
                if(error.response.status === 401) {
                    messageApi.error(t("error_user_password"))
                }
                else {
                    messageApi.error(t("error_server"))
                }
            }
        }
    }

    useEffect(() => {
        const user = localStorage.getItem("user");
        const pass = localStorage.getItem("pass");

        if(pass !== null) {
            const bytes  = CryptoJS.AES.decrypt(pass, config.passEncrypt);
            const originalPass = bytes.toString(CryptoJS.enc.Utf8);

            setUser(user);
            setPassword(originalPass);
            setCheck(true);
        }
    }, [])

    return (
        <Flex style={{ width: "100%", height: "100vh", padding: "60px 50px" }}>
            <Flex style={{ width: "100%", height: "100%" }}>
                <Flex className="shadow1" align="center" justify="center" style={{ width: "30%", height: "100%" }}>
                    <Image width={260} src={getConfig("logo")==="" ? LogoMurphy : getConfig("logo")} alt="Logo Murphy" />
                </Flex>
                <Flex className="shadow2" vertical align="center" justify="center" style={{ width: "70%", height: "100%" }}>
                    <Title level={2} style={{ color: getConfig("colorPrimario") }}>{t("title_login")}</Title>

                    <Flex vertical style={{ width: "70%", marginBottom: "20px" }}>
                        <Title level={4}>{t("input_user")}</Title>
                        <Input onChange={(e) => setUser(e.target.value)} value={user} placeholder="Usuario" size="large" prefix={<UserOutlined style={{ color: getConfig("colorPrimario") }} />} />
                    </Flex>

                    <Flex vertical style={{ width: "70%", marginBottom: "10px" }}>
                        <Title level={4}>{t("input_password")}</Title>
                        <Input.Password onChange={(e) => setPassword(e.target.value)} value={password} placeholder="Contraseña" size="large" prefix={<LockOutlined style={{ color: getConfig("colorPrimario") }} />} />
                    </Flex>

                    <Flex justify="flex-end" style={{ width: "70%", marginBottom: "20px" }}>
                        <Checkbox onChange={(e) => setCheck(e.target.checked)} checked={check}>{t("check_login")}</Checkbox>
                    </Flex>

                    <Flex justify="center" style={{ width: "70%" }}>
                        <Button onClick={onLogin} loading={cargando} ghost size="large" style={{ width: "100%", color: getConfig("colorPrimario"), borderColor: getConfig("colorPrimario") }}>{t("btn_login")}</Button>
                    </Flex>
                </Flex>
            </Flex>

            <div style={{ position: "absolute", top: "0", left: "0", width: "31.6%", height: "100vh", backgroundColor: getConfig("fondo"), zIndex: "-1" }}></div>

            {contextHolder}
        </Flex>
    )
}
